import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name pkpShowMore
     * @memberof app
     *
     * @restrict A
     * @scope false
     *
     * @description
     * Algorithm taken from Delta Source `showMore` directive.
     * BTCPKP-7311: HPQC-3706 // CR-U Fold out of alert component for TSO notices // Also titled as CR 368 Design Fixes – Footer, NavBar, NoticeBox
     *
     * This has been changed in another CR in that the default should be to show all content and have the possibility
     * to show less.
     * BTCPKP-8782: HPQC-5441 // General - TSO notice box - show full content by default
     *
     * @author flzemke.btc
     */
    angular.module('app').directive('pkpShowMore', pkpShowMore);

    function pkpShowMore() {
        return {
            restrict: 'A',
            scope: false,
            link: linkFn
        };

        function linkFn(scope, elem, attrs) {
            scope.isExpanded = isExpanded;

            elem.bind('click', onClick);

            /**
             * @memberof pkpShowMore
             * @returns {boolean}
             */
            function isExpanded() {
                if (attrs.pkpShowMore !== 'pkp-show-more') {
                    return angular
                        .element(attrs.pkpShowMore)
                        .hasClass('expanded');
                } else {
                    return elem.next('.summary').hasClass('expanded');
                }
            }

            /**
             * Add CSS classes `expanded` and `summary` accordingly.
             *
             * @memberof pkpShowMore
             * @param e
             */
            function onClick(e) {
                e.preventDefault();
                e.stopPropagation();

                scope.$apply(function () {
                    if (!scope.isExpanded()) {
                        if (attrs.pkpShowMore !== 'pkp-show-more') {
                            angular
                                .element(attrs.pkpShowMore)
                                .addClass('expanded');
                        } else {
                            elem.next('.summary').addClass('expanded');
                        }
                    } else {
                        if (attrs.pkpShowMore !== 'pkp-show-more') {
                            angular
                                .element(attrs.pkpShowMore)
                                .removeClass('expanded');
                        } else {
                            elem.next('.summary').removeClass('expanded');
                        }
                    }
                });
            }
        }
    }
})();
